'use strict';
import * as $j_app$002epages$002e$002dDocuments$002dRead$002dPage$0024$002dNode$00241 from "./app.pages.-Documents-Read-Page$-Node$1.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_pages_DocumentsReadPage$Node$3$(labelProperty$9) {
  this.aic = null;
  this.aic = labelProperty$9;
}
export { $c_Lapp_pages_DocumentsReadPage$Node$3$ as $c_Lapp_pages_DocumentsReadPage$Node$3$ };
$p = $c_Lapp_pages_DocumentsReadPage$Node$3$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_pages_DocumentsReadPage$Node$3$;
/** @constructor */
function $h_Lapp_pages_DocumentsReadPage$Node$3$() {
}
export { $h_Lapp_pages_DocumentsReadPage$Node$3$ as $h_Lapp_pages_DocumentsReadPage$Node$3$ };
$h_Lapp_pages_DocumentsReadPage$Node$3$.prototype = $p;
$p.bnO = (function(id, text) {
  return new $j_app$002epages$002e$002dDocuments$002dRead$002dPage$0024$002dNode$00241.$c_Lapp_pages_DocumentsReadPage$Node$1(this.aic, id, text);
});
$p.n = (function() {
  return "Node";
});
$p.bLh = (function(x$0) {
  return new $j_app$002epages$002e$002dDocuments$002dRead$002dPage$0024$002dNode$00241.$c_Lapp_pages_DocumentsReadPage$Node$1(this.aic, x$0.e(0), x$0.e(1));
});
$p.U = (function(p) {
  return this.bLh(p);
});
var $d_Lapp_pages_DocumentsReadPage$Node$3$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_pages_DocumentsReadPage$Node$3$, "app.pages.DocumentsReadPage$Node$3$", ({
  HI: 1,
  d: 1,
  e: 1
}));
export { $d_Lapp_pages_DocumentsReadPage$Node$3$ as $d_Lapp_pages_DocumentsReadPage$Node$3$ };
//# sourceMappingURL=app.pages.-Documents-Read-Page$-Node$3$.js.map
